import makeStyles from '@mui/styles/makeStyles';

export const useStylesUrinalysis = makeStyles((theme) => ({
    background: {
        backgroundColor: theme.palette.background.paperDarker,
    },
    dialogTitle: {
        textAlign: 'center',
        padding: '10px',
        fontWeight: 'bold',
    },
    dialogContent: {
        width: '100%',
        height: '100%',
    },
    fullWidth: {
        width: '100%',
    },
    divider: {
        padding: '10px 0px',
        width: '100%',
    },
    adderBorder: {
        border: 'solid 1px #b9b9b9',
        borderRadius: 5,
        padding: 5,
        width: '100%',
    },
    adder: {
        width: '100%',
        minHeight: 380,
    },
    footer: {
        bottom: 0,
        left: 0,
        position: 'fixed',
    },
    title: {
        textAlign: 'center',
        paddingBottom: 5,
    },
    tableRow: {
        '&:hover': {
            background: theme.palette.mode === 'dark' ? '#414141' : '#ccc',
        },
    },
    headCell: {
        fontSize: 'small',
        background: theme.palette.background.default,
    },
    rowCell: {
        fontSize: 'small',
        '&.odd': {
            background: theme.palette.mode === 'light' ? '#d1d1d1' : '#666666',
        },
    },
    colourBrick: {
        display: 'flex',
        justifyContent: 'center',
        width: 100,
        height: 10,
    },
    testBar: {
        width: 50,
        height: 50,
        borderRadius: 10,
        '&.non-pointer': {
            pointerEvents: 'none',
        },
    },
    infoBox: {
        borderRadius: '5px',
        border: '1px solid #7199E6',
        backgroundColor: theme.palette.warning.main,
        padding: 5,
        color: theme.palette.mode === 'light' ? '#fff' : '#000',
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 'large',
    },
    mainTestBox: {
        width: '100%',
        marginTop: 15,
        padding: 10,
    },
    testEntry: {
        width: '100%',
        backgroundColor: theme.palette.background.default,
        padding: 5,
        marginBottom: 10,
        '&.paper-background': {
            backgroundColor: theme.palette.background.paper,
        },
    },
    valuesBox: {
        marginLeft: 5,
    },
    values: {
        marginLeft: 15,
        textAlign: 'center',
        width: 100,
    },
    emptyInfo: {
        textAlign: 'center',
        fontSize: 'large',
        fontWeight: 'bold',
        width: '100%',
    },
    strikethrough: {
        textDecoration: 'line-through',
    },
    additionalInfo: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        margin: 8,
    },
    backgroundOverride: {
        backgroundColor: `${theme.palette.inPatient.formBackground} !important`,
    },
    actionNoDivider: {
        borderBottom: 'none',
    },
}));